import PreBookingSettingsTab from './pre-booking-settings';

export default PreBookingSettingsTab;
